module.exports = __webpack_public_path__ + "media/1x1/gd-56fdbab2.svg";